export default __webpack_public_path__ + "static/media/icon-titulo-esports.a791bd6e.svg";